import {
  CtaLinkList,
  CtaLinkListProps,
} from "design-system/components/blocks/cta-link-list/cta-link-list";
import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { CTALinkListEntry } from "frontend/contentful/schema/blocks";
import { useContentful } from "frontend/hooks/use-contentful";
import { createComponentHeaderProps } from "../primitives/component-header.props";
import { createCtaLinkProps } from "../primitives/cta-link.props";

export const ContentfulCTALinkList =
  createContentfulComponent<CTALinkListEntry>(({ entry }) => {
    const { getEntry, getEntries } = useContentful();

    const props: CtaLinkListProps = {
      align: entry.fields.alignment,
      label: entry.fields.label,
      hideIcon: entry.fields.hideIcon,
      items: [],
    };

    if (entry.fields.header) {
      const header = getEntry(entry.fields.header);
      if (header) {
        props.headerContent = createComponentHeaderProps(header);
      }
    }

    getEntries(entry.fields.items).forEach((simpleCTA) => {
      const simpleCTAHideIcon = simpleCTA.fields.hideIcon;
      getEntries(simpleCTA.fields.links).forEach((linkEntry) => {
        const linkProps = createCtaLinkProps(linkEntry);
        const linkHideIcon = linkProps?.hideIcon;
        if (linkProps) {
          const hideIcon = simpleCTAHideIcon || linkHideIcon;
          props.items?.push({ ...linkProps, hideIcon });
        }
      });
    });

    return <CtaLinkList {...props} />;
  });
